import $ from "jquery";

const vendorGravityForm = () => {
  const init = () => {
    const currentLang = getCurrentLanguage();
    const errorMessage = getErrorMessage(currentLang);
    const labels = getPhoneLabels();

    attachValidation(labels, errorMessage);
  };

  const getCurrentLanguage = () => {
    return $("html").attr("lang");
  };

  const getErrorMessage = (lang) => {
    const messages = {
      "en-US": "Please enter a valid phone number.",
      "fr-FR": "Veuillez saisir un numéro de téléphone valide.",
      "de-DE": "Bitte geben Sie eine gültige Telefonnummer ein.",
    };

    return messages[lang] || "Voer een geldig telefoonnummer in.";
  };

  const getPhoneLabels = () => {
    return [
      "telefoonnummer",
      "telephone number",
      "phone number",
      "telefonnummer",
      "numéro de téléphone",
    ];
  };

  const attachValidation = (labels, errorMessage) => {
    $("label")
      .filter(function () {
        let labelText = $(this).text().trim().toLowerCase();
        labelText = labelText.replace(/\*/g, "").trim();

        return labels.includes(labelText);
      })
      .each(function () {
        const relatedInput = getRelatedInput($(this));
        relatedInput.on("input", function () {
          handleInputChange($(this), errorMessage);
        });
      });
  };

  const getRelatedInput = (label) => {
    return label
      .closest(".gfield_label")
      .next(".ginput_container")
      .find("input");
  };

  const handleInputChange = (input, errorMessage) => {
    const inputValue = input.val();
    const validationMessageId = getValidationMessageId(input.attr("id"));

    removeValidationMessage(validationMessageId);

    if (containsAlphabet(inputValue)) {
      displayValidationMessage(input, validationMessageId, errorMessage);
      disableSubmitButton();
    } else {
      enableSubmitButton();
    }
  };

  const getValidationMessageId = (inputId) => {
    const parts = inputId.split("_");
    return `validation_message_${parts[1]}_${parts[2]}`;
  };

  const removeValidationMessage = (id) => {
    $("#" + id).remove();
  };

  const containsAlphabet = (value) => {
    return /[a-zA-Z]/.test(value);
  };

  const displayValidationMessage = (input, messageId, errorMessage) => {
    const validationMessage = `
      <div id="${messageId}" class="gfield_description validation_message gfield_validation_message">
        ${errorMessage}
      </div>
    `;
    input.closest(".ginput_container").append(validationMessage);
  };

  const disableSubmitButton = () => {
    $('input[type="submit"]')
      .attr("disabled", "disabled")
      .attr("readonly", "readonly");
  };

  const enableSubmitButton = () => {
    $('input[type="submit"]').removeAttr("disabled").removeAttr("readonly");
  };

  init();
};

try {
  vendorGravityForm();
} catch (error) {
  console.error("vendorGravityForm", error);
}
